import styled from 'styled-components'

export const MusicLibSoundsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
`
